import React, { useEffect, useState } from "react";
import { Menu, X, Shield } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { Button } from "./ui/button";

const Navbar = () => {
  const { player, navLinks } = useContent();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-black/85 backdrop-blur-md border-b border-neutral-800"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-3 group">
          <span className="flex items-center justify-center w-10 h-10 rounded-sm bg-red-600 text-white font-display text-xl shadow-lg shadow-red-900/30">
            <Shield className="w-5 h-5" />
          </span>
          <div className="leading-tight">
            <div className="font-display text-xl tracking-wider text-white">
              {player.firstName.toUpperCase()}{" "}
              <span className="text-red-500">{player.lastName.toUpperCase()}</span>
            </div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-neutral-400">
              DE / DT · Class of {player.classOf}
            </div>
          </div>
        </a>

        <ul className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <li key={l.label}>
              <a
                href={l.href}
                className="nav-link text-sm uppercase tracking-widest text-neutral-300 hover:text-white font-heading"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden lg:block">
          <Button
            asChild
            className="btn-primary bg-red-600 hover:bg-red-700 text-white font-heading uppercase tracking-widest rounded-sm px-6"
          >
            <a href="#contact">Scout Me</a>
          </Button>
        </div>

        <button
          aria-label="Toggle menu"
          onClick={() => setOpen((s) => !s)}
          className="lg:hidden text-white p-2"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-black/95 backdrop-blur border-t border-neutral-800">
          <ul className="px-5 py-6 space-y-4">
            {navLinks.map((l) => (
              <li key={l.label}>
                <a
                  onClick={() => setOpen(false)}
                  href={l.href}
                  className="block text-neutral-200 font-heading uppercase tracking-widest text-sm py-2 border-b border-neutral-800"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                onClick={() => setOpen(false)}
                href="#contact"
                className="block text-center bg-red-600 hover:bg-red-700 text-white font-heading uppercase tracking-widest rounded-sm py-3 mt-4"
              >
                Scout Me
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navbar;
